import TextField from '@mui/material/TextField';
import React from 'react';
import FormWithDescription from '../../FormWithDescription';

export default function MainOptions({
  blogTitle,
  setBlogTitle,
  blogSlogan,
  setBlogSlogan,
  showValidation,
  isAdvanced,
}) {
  return (
    <>
      <div>
        <FormWithDescription
          title={
            isAdvanced ? (
              'Blog name'
            ) : (
              <>
                Blog name <span className="tw-text-red-400">*</span>
              </>
            )
          }
          description={
            'The blog name is the title of your site.' +
            (isAdvanced ? '' : ' You can edit it anytime.')
          }
        >
          <TextField
            placeholder={isAdvanced ? undefined : 'Pirate Ponders'}
            fullWidth
            label="Blog name"
            variant="outlined"
            value={blogTitle}
            onChange={e => setBlogTitle(e.target.value)}
            inputProps={{
              maxLength: 25,
            }}
            error={showValidation && !blogTitle}
            helperText={
              showValidation && !blogTitle ? 'Please choose a blog title' : ''
            }
          />
        </FormWithDescription>
        <FormWithDescription
          title={isAdvanced ? 'Meta description' : 'What is your blog about?'}
          description={
            isAdvanced
              ? 'This text will be the preview when your homepage appears on Google or you link to it from social media.'
              : `Our AI will write the "About Me" sections from this.`
          }
          marginTop
        >
          <TextField
            fullWidth
            id="blogSlogan"
            label={isAdvanced ? 'Meta description' : 'What is your blog about?'}
            variant="outlined"
            placeholder={
              isAdvanced
                ? undefined
                : `I'm Jack Sparrow, a pirate. I have been to all the seven seas, but mostly travel in the Caribbean and write about photography, sailing and rum. Follow me for hidden treasures!`
            }
            rows={isAdvanced ? undefined : 3}
            value={blogSlogan}
            onChange={e => setBlogSlogan(e.target.value)}
            inputProps={{
              maxLength: isAdvanced ? 160 : 300,
            }}
            multiline
          />
        </FormWithDescription>
      </div>
    </>
  );
}
